module.exports = __webpack_public_path__ + "static/media/logo-cftb-white-2024.004d3f30.png";